import { render } from "./AppImg.vue?vue&type=template&id=8f29f128&scoped=true&ts=true"
import script from "./AppImg.vue?vue&type=script&lang=ts"
export * from "./AppImg.vue?vue&type=script&lang=ts"

import "./AppImg.vue?vue&type=style&index=0&id=8f29f128&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f29f128"]])

export default __exports__